import React, { useState, useRef, useEffect } from 'react'
import {
   Button, Grow, Paper, Popper, ClickAwayListener, MenuList, MenuItem
} from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress';
import dayjs from 'dayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'


export default function FilterDropdownBlog_main({ posts, setPosts, selectedSubItems, setSelectedSubItems, visibilityFilter, setVisibilityFilter, allOwners, setAllOwners, handleSubItem, cleanListItem, dateFrom, setDateFrom, dateTo, setDateTo, makeRequest, setMakeRequest, resetAll, handleActiveFilters, activeFilters }) {
   const [mainOpen, setMainOpen] = useState(false)
   const [activeSubMenu, setActiveSubMenu] = useState(null)
   const [items, setItems] = useState([])
   const [subMenuReady, setSubMenuReady] = useState(false)


   const anchorRef = useRef(null)
   const subAnchorRef = useRef(null)


   //додатковий реф на пейпері суб меню,щоб лапати клік
   const subMenuPaperRef = useRef(null);

   //юзефект для обробки масиву айтемів

   useEffect(() => {
      const result = [

         {
            key: 'Visibility',
            label: 'Visibility',
            slug: 'Visibility',
            options: [
               { id: 'visible', name: 'Visible', slug: 'Visibility' },
               { id: 'non_visible', name: 'Hidden', slug: 'Visibility' }
            ]
         },

         // вставка post id
         {
            key: 'Posts',
            label: `Id's`,
            slug: 'Posts',
            options: [...posts]
         },
         // вставка post id(верх)
         {
            key: 'Owners',
            label: 'Author',
            slug: 'Owners',
            options: [...allOwners]
            //  [
            //    { id: 'visible', name: 'Visible', slug: 'Visibility' },
            //    { id: 'non_visible', name: 'Non visible', slug: 'Visibility' }
            // ]
         },
         //Вставка пункта даты
         {
            key: 'Date_of_start',
            label: 'Start date',
            slug: 'Date_of_start',
            // options: [...coordinatorAll]
         },
      ];


      setItems(result);
   }, [selectedSubItems]);
   ///юзефект для обробки масиву айтемів(верх)

   useEffect(() => {
      if (!mainOpen) {
         //стани які необхідно скидати для очищення,setMakeRequest потрібен для дат і запиту після очищення
         // setSelectedSubItems([])
         // setVisibilityFilter(undefined)
         // setDateFrom(null)
         // setDateTo(null)
         // setMakeRequest(true)
      } else {
         // setMakeRequest(false)
      }

   }, [mainOpen])

   const handleToggleMain = () => {
      setMainOpen(prev => !prev)
      setActiveSubMenu(null)

   }

   const handleCloseAll = (e) => {
      if (
         e.target.closest('.MuiPickersPopper-root') ||
         subMenuPaperRef.current?.contains(e.target)
      ) {

         return
      }
      setMainOpen(false)
      setActiveSubMenu(null)

   }


   const onMainMenuMouseEnter = (key) => {

      setActiveSubMenu(key)
   };

   useEffect(() => {
      if (activeSubMenu) {
         setSubMenuReady(false);
         const timer = setTimeout(() => {
            setSubMenuReady(true);
         }, 10);
         return () => clearTimeout(timer);
      } else {
         setSubMenuReady(false);
      }
   }, [activeSubMenu]);


   // console.log('items', items)
   // console.log('allOwners', allOwners)
   // console.log('selectedSubItems', selectedSubItems)
   // console.log('activeFilters', activeFilters)

   return (
      <div style={{ order: '2' }}>
         <Button className='dropdown-filter-button'
            ref={anchorRef}
            variant="outlined"
            onClick={handleToggleMain}
         >
            <span>
               <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 10H15M2.5 5H17.5M7.5 15H12.5" stroke="#434349" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
               </svg>
            </span>
            <span className='dropdown-filter-button-text'>Filters</span>
         </Button>

         <Popper
            className='dropdown-custom-popper'
            open={mainOpen}
            anchorEl={anchorRef.current}
            placement="bottom-start"
            // placement='right-end'
            transition
            disablePortal
            modifiers={[
               {
                  name: 'offset',
                  options: {
                     offset: [-100, 10],
                  },
               },
            ]}
         >
            {({ TransitionProps }) => (
               <Grow {...TransitionProps}>
                  <Paper className='dropdown-custom-paper'>

                     <ClickAwayListener onClickAway={handleCloseAll}>

                        {

                           <MenuList autoFocusItem>
                              {items.map(attribute => {

                                 const isMainSelected =
                                    (attribute.slug === 'Visibility' && visibilityFilter === 'visible') ||
                                    (attribute.slug === 'Visibility' && visibilityFilter === 'non_visible') ||
                                    (attribute.slug === 'Date_of_start' && dateFrom && dateTo) ||
                                    selectedSubItems.some(
                                       item => item.slug === attribute.slug
                                    );
                                 // console.log('isMainSelected', isMainSelected)
                                 return <MenuItem
                                    className={`main-dropdown-custom-menu-item ${isMainSelected ? 'selected' : ''}`}
                                    key={attribute.key}
                                    // style={{
                                    //    borderTop: attribute.slug === 'Country' ? '1px solid #eeeef0' : '',

                                    //    borderBottom: attribute.slug === 'Settlement' ? '1px solid #eeeef0' : ''

                                    // }}

                                    ref={attribute.key === activeSubMenu ? subAnchorRef : null}
                                    // onMouseEnter={() => setActiveSubMenu(attribute.key)}
                                    onMouseEnter={() => onMainMenuMouseEnter(attribute.key)}
                                    onMouseLeave={() => {
                                       // activeSubMenu === attribute.key && setActiveSubMenu(null)
                                    }
                                    }
                                 >
                                    {attribute.label}
                                    <span>
                                       <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <g opacity="0.5">
                                             <path d="M6 12L10 8L6 4" stroke="#434349" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                          </g>
                                       </svg>
                                    </span>
                                 </MenuItem>
                              }

                              )}

                              <MenuItem className='main-dropdown-custom-menu-item'
                                 onClick={resetAll}
                              >
                                 <span style={{ fontWeight: '700', color: 'black' }}>Reset all</span>
                              </MenuItem>
                           </MenuList>}

                     </ClickAwayListener>
                  </Paper>
               </Grow>
            )}
         </Popper>

         {


            items.map(filter =>
               activeSubMenu === filter.key
                  && subAnchorRef.current
                  ? (
                     <Popper
                        className='sub-dropdown-custom-popper'
                        key={filter.key}
                        open
                        anchorEl={subAnchorRef.current}
                        placement="right-start"
                        // placement='right-end'
                        transition
                        disablePortal
                     >
                        {({ TransitionProps }) => (
                           <Grow {...TransitionProps}>
                              <Paper
                                 className='sub-dropdown-custom-papper'
                                 onMouseEnter={() => setActiveSubMenu(filter.key)}
                                 onMouseLeave={() => {
                                    // setActiveSubMenu(null)
                                 }}
                                 ref={subMenuPaperRef}
                              >

                                 {/* <div className='sub-dropdown-custom-paper-inner'> */}
                                 {
                                    filter.slug !== 'Date_of_start' &&


                                    <MenuList className='sub-dropdown-custom-menu' autoFocusItem>

                                       {filter.options.length > 0 && <MenuItem
                                          key={`clean-item ${filter.key}`}
                                          className='sub-dropdown-custom-menu-item'
                                          onClick={() => cleanListItem(filter?.slug)}
                                       >
                                          not set
                                       </MenuItem>}

                                       {filter.options.map(option => {

                                          const isSelected =
                                             (option.slug === 'Visibility' && option.id === visibilityFilter) ||

                                             selectedSubItems.some(
                                                item => item.slug === filter.slug && item.id === option.id
                                             );


                                          return (
                                             <MenuItem
                                                key={`${option.id} ${filter.slug}`}
                                                className={`sub-dropdown-custom-menu-item ${isSelected ? 'selected' : ''}`}
                                                onClick={() => {
                                                   // console.log('clickedOption', option)
                                                   handleActiveFilters(filter.slug, filter.label, option.slug, option.name, option.id, option.firstName || undefined, option.lastName || undefined)
                                                   if (option.slug === 'Visibility') {
                                                      setVisibilityFilter(option.id);
                                                      return
                                                   }
                                                   else {
                                                      handleSubItem(option.id, filter.slug)
                                                   }
                                                }
                                                }
                                             >
                                                {filter.slug === 'Owners' ? `${option.firstName} ${option.lastName}` : ''}
                                                {filter.slug === 'Posts' ? option.id : ''}
                                                {/* {filter.slug !== 'Owners' ? option.name : `${option.firstName} ${option.lastName}`} */}
                                                {(filter.slug !== 'Owners' && filter.slug !== 'Posts') ? option.name : ''}
                                             </MenuItem>
                                          );
                                       })}


                                    </MenuList>}
                                 {
                                    filter.slug === 'Date_of_start' &&
                                    <MenuList className='sub-dropdown-custom-menu' autoFocusItem>
                                       <LocalizationProvider
                                          dateAdapter={AdapterDayjs}
                                       >
                                          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                                             <MenuItem
                                                className='sub-dropdown-custom-menu-item'
                                                onClick={() => {
                                                   setDateFrom(null)
                                                   setDateTo(null)
                                                   setMakeRequest(true)
                                                   // cleanListItem(filter?.slug)
                                                }}
                                             >
                                                clean dates
                                             </MenuItem>
                                             <MenuItem
                                                // key={`clean-item ${filter.key}`}
                                                className='sub-dropdown-custom-menu-item'
                                             // onClick={() => cleanListItem(filter?.slug)}
                                             >
                                                <DatePicker
                                                   label="Date_from"
                                                   value={dateFrom}
                                                   onChange={(newValue) => setDateFrom(newValue)}
                                                   format="YYYY-MM-DD"
                                                   maxDate={dateTo ?? undefined}
                                                   slotProps={{
                                                      textField: {
                                                         size: 'small',
                                                         fullWidth: true,
                                                         variant: 'standard',
                                                      },
                                                   }}
                                                />
                                             </MenuItem>
                                             <MenuItem
                                                // key={`clean-item ${filter.key}`}
                                                className='sub-dropdown-custom-menu-item'
                                             // onClick={() => cleanListItem(filter?.slug)}
                                             >

                                                <DatePicker
                                                   label="Date_to"
                                                   value={dateTo}
                                                   onChange={(newValue) => setDateTo(newValue)}
                                                   format="YYYY-MM-DD"
                                                   minDate={dateFrom ?? undefined}
                                                   slotProps={{
                                                      textField: {
                                                         size: 'small',
                                                         fullWidth: true,
                                                         variant: 'standard',
                                                      },
                                                   }}
                                                />
                                             </MenuItem>
                                          </div>
                                       </LocalizationProvider>
                                    </MenuList>
                                 }


                                 {/* </div> */}

                              </Paper>
                           </Grow>
                        )}
                     </Popper>
                  ) : null
            )
         }

      </div>
   )
}